var React = require('react');

function Plus (props) {
    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M17.25 8.75h-7.5v-7.5a.75.75 0 0 0-1.5 0v7.5H.75a.75.75 0 0 0 0 1.5h7.5v7.5a.75.75 0 1 0 1.5 0v-7.5h7.5a.75.75 0 1 0 0-1.5z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"translate(0 .5)","d":"M0 0h18v18H0z"})))]);
}

Plus.displayName = "Plus";

Plus.defaultProps = {"viewBox":"0 0 18 19"};

module.exports = Plus;

Plus.default = Plus;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/plus.svg
// module id = 1282
// module chunks = 0